import { Injectable } from '@angular/core'

//import { AuthProvider } from '../../providers/auth/auth';
import { SignalingServerType } from '../../models/models'

@Injectable()
export class ConfigProvider {
	public static readonly APPLICATION_NAME: string = "Eta Desk";
	/**
	Se l'altro non risponde entro questi secondi, mette giù
	*/
	public static readonly CALL_ANSWER_TIMEOUT: number = 60;
	public static readonly CALL_BUZZ_URI = 'assets/ringtones/buzz_in_1.mp3';
	public static readonly CALL_BUZZ_ID = 'CALL_BUZZ_ID';

	public static readonly FIREBASE_CONFIG = {
		apiKey: "AIzaSyDa6vn6exP4y_Eco3abZ5ZRM0XrJidiSXk",
		authDomain: "idesk-signaling.firebaseapp.com",
		databaseURL: "https://idesk-signaling.firebaseio.com",
		projectId: "idesk-signaling",
		storageBucket: "idesk-signaling.appspot.com",
		messagingSenderId: "1055843623977"
	}

	public static readonly SIGNALING_SOCKETIO = {
		url: 'https://idesk.ethicsoft.it:20179',
		config: {
			//path: 'eta-desk'
			autoConnect: false,
			policyPort: 20180,
			//prima websocket, poi polling
			transports: ['websocket', 'polling']
		}
	}

	public static readonly MEDIA_STREAM_AUDIO_DEFAULT = true; //{ echoCancellation: true, noiseSuppression: true };
	public static readonly MEDIA_STREAM_VIDEO_DEFAULT = true; //{ facingMode: { ideal: 'user' } };

	public static readonly NOTIFICATION_CHANNEL_NEWMESSAGE: string = "notification.channel.message.new";
	public static readonly NOTIFICATION_CHANNEL_UNREADMESSAGE: string = "notification.channel.message.unread";

	public static readonly RTC_PEER_ICE_SERVERS_PRIVATE=[
		{
			urls: "turn:idesk.ethicsoft.it:3478",
			credential: "m4stiqu4tz12025",
			username: "webrtcuser",
		},
		{
			urls: "turn:idesk.ethicsoft.it:3478",
			credential: "m4stiqu4tz12025",
			username: "webrtcuser",
		}
	];

	public static readonly RTC_PEER_ICE_SERVERS_PUBLIC = [
		{ urls: "stun:stun.l.google.com:19302" },
		{ urls: 'stun:stun.services.mozilla.com' },
		//{ urls: 'stun:numb.viagenie.ca', credential: '88888888', username: 'luca.colombi@ethicsoft.it' },

		//{ urls: 'turn:turn.ethicsoft.it:20178', credential: 'turnpassword', username: 'turnuser' },
		{
			urls: 'turn:numb.viagenie.ca',
			credential: '88888888',
			username: 'luca.colombi@ethicsoft.it'
		},

		{//quite slow
			urls: 'turn:turn.anyfirewall.com:443?transport=tcp',
			credential: 'webrtc',
			username: 'webrtc'
		},

		/*
		{ urls: 'turn:turn01.hubl.in?transport=udp' },
		{ urls: 'turn:turn02.hubl.in?transport=tcp' },
		*/
		/*
		{
		urls: 'turn:turn.bistri.com:80',
		credential: 'homeo',
		username: 'homeo'
	},
	*/

		//	{ url: 'stun:217.61.58.219:3478' },
		//{ urls: 'turn:217.61.58.219:3478', credential: 'turnpassword', username: 'turnuser' },
		//{ urls: 'turn:turn.ethicsoft.it:20178', credential: 'turnpassword', username: 'turnuser' },
	];

	public static readonly RTC_PEER_CONNECTION_CONFIGURATION = {
		iceServers: [
			{ urls: "stun:stun.l.google.com:19302" },
			{ urls: 'stun:stun.services.mozilla.com' },
			//{ urls: 'stun:numb.viagenie.ca', credential: '88888888', username: 'luca.colombi@ethicsoft.it' },

			//{ urls: 'turn:turn.ethicsoft.it:20178', credential: 'turnpassword', username: 'turnuser' },
			{
				urls: 'turn:numb.viagenie.ca',
				credential: '88888888',
				username: 'luca.colombi@ethicsoft.it'
			},

			{//quite slow
				urls: 'turn:turn.anyfirewall.com:443?transport=tcp',
				credential: 'webrtc',
				username: 'webrtc'
			},

			/*
			{ urls: 'turn:turn01.hubl.in?transport=udp' },
			{ urls: 'turn:turn02.hubl.in?transport=tcp' },
			*/
			/*
			{
			urls: 'turn:turn.bistri.com:80',
			credential: 'homeo',
			username: 'homeo'
		},
		*/
			{
				urls: 'turn:turn.anyfirewall.com:443?transport=tcp',
				credential: 'webrtc',
				username: 'webrtc'
			}

			//	{ url: 'stun:217.61.58.219:3478' },
			//{ urls: 'turn:217.61.58.219:3478', credential: 'turnpassword', username: 'turnuser' },
			//{ urls: 'turn:turn.ethicsoft.it:20178', credential: 'turnpassword', username: 'turnuser' },
		]
	};

	/**
	Configurazione della connessione per PeerJS
	*/
	public static readonly PEER_SERVER_OPTIONS = {
		host: '217.61.58.219',
		port: 20178,
		path: '/idesk',
		//key: 'lwjd5qra8257b9',
		debug: 1,
		token: 'sticazzi',
		//'iceServers': ConfigProvider.RTC_PEER_CONNECTION_CONFIGURATION.iceServers
	};


	/**
	Prefisso id univoco utente per PeerJS
	*/
	public static readonly PEER_USER_ID_PREFIX: string = 'itEthicsoftIdeskUser';
	public static readonly PEER_DEVICE_IDENTIFIER_PREFIX: string = 'itEthicsoftIdeskDevice';

	public static readonly HOST: string = "https://idesk.ethicsoft.it/api";
	/**
	Massimo tempo per login
	*/
	public static readonly TIMEOUT_LOGIN: number = 10;
	/**
	Timeout in secondi dopo il quale le UI di interazione (modali, menu, selezioni...) se sono temporanee si chiudono automaticamente
	*/
	public static readonly TIMEOUT_INTERACTION: number = 60;
	/**
	Timeout in secondi dopo il quale la chiamata senza risposta si chiude automaticamente
	*/
	public static readonly TIMEOUT_CALL_ANSWER: number = 30;
	/**
	Timeout in secondi perchè durante una chiamata in streaming venga considerata la connessione persa se non si riesce a ricevere
	*/
	public static readonly TIMEOUT_CALL_CONNECTION: number = 5;
	/**
	Intervallo di aggiornamento della configurazione del dispositivo corrente, default
	*/
	public static readonly TIMEOUT_DEVICE_ACTUAL_REFRESH_DEFAULT: number = 1800;//30'
	/**
	Ricarica il dispositivo corrente, bacheca
	*/
	public static readonly TIMEOUT_DEVICE_ACTUAL_REFRESH_DASHBOARD: number = 300;
	/**
	Intervallo di aggiornamento della configurazione del dispositivo corrente, citofono
	*/
	public static readonly TIMEOUT_DEVICE_ACTUAL_REFRESH_INTERCOM: number = 300;//5'
	/**
	Secondi tra un frame e l'altro della telecamera di sicurezza
	*/
	public static readonly TIMEOUT_SECURITY_CAM_FRAME: number = 3;

	public static readonly INTERVAL_USER_MESSAGE_POLLING_FOREGROUND: number = 60;//1'
	public static readonly INTERVAL_USER_MESSAGE_POLLING_BACKGROUND: number = 1800;//30'


	/**
	Se true è il chiamante a fare la prima Offer, altrimenti è il chiamato
	*/
	public static WEBRTC_CALLER_SEND_OFFER: boolean = false;//non readonly, eventualmente configurabile dinamicamente
	/**
	Se true l'inizio della negoziazione è condizionato all'avere uno stream da inviare
	*/
	public static WEBRTC_SEND_OFFER_REQUIRE_STREAM: boolean = false;//non readonly, eventualmente configurabile dinamicamente

	/**
	 * Dopo l'invio del ping pre-chiamata, quanti secondi attende prima di rinunciare al tentativo di chiamata VOIP
	*/
	public static TIMEOUT_CALL_VOIP_PING: number = 30;

	/**
	"peerJS"	o "firebase"
	*/
	public static readonly SIGNALING_SERVER_TYPE: SignalingServerType = SignalingServerType.SOCKETIO;



	/**
	Crea il token identifier univoco per connettere un dispositivo
	*/
	public static generatePeerIdDevice(deviceIdentifier: string) {
		return ConfigProvider.PEER_DEVICE_IDENTIFIER_PREFIX + 'D' + deviceIdentifier
	}
	/**
	Crea il token identifier univoco per connettere un utente
	*/
	public static generatePeerIdUser(userId: number) {
		let pid = ConfigProvider.PEER_USER_ID_PREFIX + 'U' + userId.toString()
		console.debug('[ConfigProvider.generatePeerIdUser(' + userId + ')] Peer ID generato: ' + pid)
		return pid
	}
}



// WEBPACK FOOTER //
// ./src/providers/config/config.ts